import React from 'react';
import { clsx, createUseStyles } from '@pushpay/styles';
const useStyles = createUseStyles(theme => ({
  root: {
    height: '40px',
    borderLeft: `1px solid ${theme.colors['palette-grey-light-100']}`
  }
}));
export function Divider({
  classes: classesProp,
  className: classNameProp
}) {
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  });
}